module.exports = __webpack_public_path__ + "static/media/darkmap.5d2191d3.png";